export const environment = {
  production: true,
  apiConstants: {
    AZURE_B2C_AUTHORITY: 'https://jhhusprod.b2clogin.com/tfp/jhhusprod.onmicrosoft.com/B2C_1A_SignUpOrSignInWithPhoneOrEmail',
    AZURE_B2C_AUTHORITY_SIGN_UP: 'https://jhhusprod.b2clogin.com/tfp/jhhusprod.onmicrosoft.com/B2C_1A_SignUpWithEmail',
    AZURE_B2C_CLIENT_ID: '50da0c8f-82d4-41da-9988-593b2ab5c35c',
    AZURE_B2C_SCOPE: 'https://jhhusprod.onmicrosoft.com/8d978a7c-b09c-4222-8db0-b90d797bb466/user_impersonation',
    GATEWAY_BASE_URL: 'https://gateway.usprod.jawbonehealth.com',
    USER_V2_API_URL: '/user/api/v0.2',
    HEALTHCLOUD_API_URL: '/healthcloud/api/v0.1',
    ADMIN_PORTAL_URL: 'https://admin-internal.email.jawbonehealth.com/',
    CLINICIAN_PORTAL_URL: 'https://jhh-internal.email.jawbonehealth.com/',
    CUSTOMER_TENANT: 'undefined'
  }
};
